// extracted by mini-css-extract-plugin
export default {"footerBackground":"styles_footerBackground__SkerA","footerContainer":"styles_footerContainer__pN7Mn"};